/* eslint-disable react/prop-types */
/**
 * @author Granite Bagas
 */

import React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import { isWeb } from '@global/screens';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import RequestProductPeriodScreen from '@/screens/request-product/RequestProductPeriodScreen';
import RequestProductScreen from '@/screens/request-product/RequestProductListScreen';
import RequestProductFormScreen from '@/screens/request-product/RequestProductFormScreen';
import RequestProductDetailScreen from '@/screens/request-product/RequestProductDetailScreen';

import RequestProductListingScreen from '@/screens/request-product/RequestProductListingScreen';
import RequestProductListingFormScreen from '@/screens/request-product/RequestProductListingFormScreen';
import RequestProductListingDetailScreen from '@/screens/request-product/RequestProductListingDetailScreen';

const Stack = createStackNavigator();

const RequestProductNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="RequestProductListScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators, true),
      })}>
      <Stack.Screen
        name="RequestProductPeriodScreen"
        component={RequestProductPeriodScreen}
        options={(props) => {
          return {
            title: setTitleHeader('Product Listing & Summary'),
            hideScroll: true,
          };
        }}
      />
      <Stack.Screen
        name="RequestProductListScreen"
        component={RequestProductScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Request Product Tester';
          if (route?.params?.titleScreen) {
            title = route.params.titleScreen;
          }

          return {
            title: setTitleHeader(title),
            hideScroll: true,
          };
        }}
      />
      <Stack.Screen
        name="RequestProductFormScreen"
        component={RequestProductFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Request Product Tester';
          if (route?.params?.id) {
            title = 'Edit Request Product Tester';
          }

          const goBack = () => {
            if (route.params && route.params.id) {
              props.navigation.navigate('RequestProductDetailScreen', {
                reference_code: route?.params?.reference_code,
                name: route?.params?.name,
                id: route?.params?.id,
                go_back_key: props.route.key,
              });
            } else {
              props.navigation.replace('RequestProductListingFormScreen', {});
              props.navigation.navigate('RequestProductListScreen', {
                go_back_key: props.route.key,
              });
            }
          };

          return {
            title: setTitleHeader(title),
            hideScroll: true,
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
          };
        }}
      />
      <Stack.Screen
        name="RequestProductDetailScreen"
        component={RequestProductDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Request Product Listing Detail';
          if (route?.params?.reference_code) {
            title = route.params.reference_code;
          }

          const goBack = () => {
            props.navigation.replace('RequestProductDetailScreen', {});
            props.navigation.navigate('RequestProductListScreen');
          };

          return {
            title: setTitleHeader(title),
            hideScroll: true,
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
          };
        }}
      />
      <Stack.Screen
        name="RequestProductListingScreen"
        component={RequestProductListingScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Product Listing & Summary';
          if (route?.params?.titleScreen) {
            title = route.params.titleScreen;
          }

          const goBack = () => {
            props.navigation.replace('RequestProductListingScreen', {});
            props.navigation.navigate('RequestProductPeriodScreen');
          };

          return {
            title: setTitleHeader(title),
            hideScroll: true,
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
          };
        }}
      />
      <Stack.Screen
        name="RequestProductListingFormScreen"
        component={RequestProductListingFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Product Listing & Summary';
          if (route?.params?.titleScreen) {
            title = 'Edit Product Listing & Summary';
          }
          const year = route?.params?.year || '';

          const goBack = () => {
            if (route.params && route.params.titleScreen) {
              props.navigation.navigate('RequestProductListingDetailScreen', {
                titleScreen: route?.params?.titleScreen,
                name: route?.params?.name,
                id: route?.params?.id,
                year: `${year}`,
                go_back_key: props.route.key,
              });
            } else {
              props.navigation.replace('RequestProductListingFormScreen', {});
              props.navigation.navigate('RequestProductListingScreen', {
                titleScreen: `${year}`,
                name: `${year}`,
                year: `${year}`,
                go_back_key: props.route.key,
              });
            }
          };

          return {
            title: setTitleHeader(title),
            hideScroll: true,
            headerLeft: () => (
              <BackButton
                {...props}
                notUseLastRoute={true}
                onPress={() => goBack()}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="RequestProductListingDetailScreen"
        component={RequestProductListingDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Product Listing & Summary Detail';
          if (route?.params?.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerRight: () => <NotificationSettingButton {...props} />,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default RequestProductNavigator;
